import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import * as S from './styles';
import * as T from './types';
import { Table, Option, Select, Button } from '../../../_core/_components';
import api from '../../../_core/api';
import { failure } from '../../../_core/services/toast';
import { FullScreenLoading } from '../../../_core/_components/fullscreen-loading';
import { AuthContext } from '../../../_main/contexts/auth';

const TableColumns = [
  { label: 'SHOPPING', key: 'nomeShopping' },
  { label: 'STATUS(WORKFLOW)', key: 'nomStatusWorkflow' },
  { label: 'DESPEJO', key: 'despejo' },
  { label: 'EXECUÇÃO', key: 'execucao' },
  { label: 'DENÚNCIA/DESPEJO', key: 'denunciaDespejo' },
  { label: 'DENÚNCIA/EXECUÇÃO', key: 'denunciaExecucao' },
];

export const STATUS_OPTIONS: Option[] = [
  {
    value: 1,
    label: 'Pendente Envio Régua',
  },
  {
    value: 2,
    label: 'Pendente Análise do Shopping',
  },
  {
    value: 3,
    label: 'Pendente Aprovação Shopping',
  },
  {
    value: 4,
    label: 'Pendente Análise Cobrança Corporativa',
  },
  {
    value: 5,
    label: 'Pendente Aprovação Régua',
  },
  {
    value: 6,
    label: 'Finalizado (Final)',
  },
  {
    value: 7,
    label: 'Pendente Aprovação Cobrança Corporativa',
  },
  {
    value: 8,
    label: 'Pendente Aprovação Diretor Shopping',
  },
  {
    value: 9,
    label: 'Pendente Aprovação Diretor Corporativo',
  },
];

const StatusWorkflow = () => {
  const { shoppings: profileShoppings } = useContext(AuthContext);
  const [data, setData] = useState<T.Total[]>();
  const [shoppings, setShoppings] = useState<Option[]>();
  const [selectedShoppings, setSelectedShoppings] = useState<Option[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<Option[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (_.isArray(profileShoppings)) {
      const optionsSorted = _.sortBy(profileShoppings, ['name'], ['asc']) ?? [];
      const optionsArr = optionsSorted.map(e => ({ value: e.id, label: e.name }));
      setShoppings(optionsArr);
    }
  }, [profileShoppings]);

  const getShoppingIds = () => {
    if (selectedShoppings.find(s => s.value === 'todos')) {
      return shoppings?.filter(s => s.value !== 'todos').map(s => s.value);
    }

    return selectedShoppings.map(s => s.value);
  };

  const getList = async () => {
    try {
      setLoading(true);
      const res = await api.get<T.Total[]>('/workflow/ajuizamento/acoes-por-shoppping/por-status', {
        params: {
          idShoppings: getShoppingIds()?.join(','),
          idStatusWorkflows: selectedStatus.map(s => s.value)?.join(','),
        },
      });

      setData(res.data);
      setLoading(false);
    } catch (e) {
      failure('Erro ao tentar carregar lista');
      setLoading(false);
    }
  };

  const handleSearch = () => {
    getList();
  };

  return (
    <S.Wrapper>
      <S.FilterBar>
        <S.FilterGroup>
          <S.FilterLabel>Shoppings</S.FilterLabel>
          <Select todos checkedByDefault state={[selectedShoppings, setSelectedShoppings]} options={shoppings || []} />
        </S.FilterGroup>
        <S.FilterGroup>
          <S.FilterLabel>Status</S.FilterLabel>
          <Select state={[selectedStatus, setSelectedStatus]} options={STATUS_OPTIONS || []} />
        </S.FilterGroup>

        <Button onClick={handleSearch} text="Buscar" />
      </S.FilterBar>
      {loading ? <FullScreenLoading isEnabled={loading} /> : <Table columns={TableColumns} data={data || []} />}
    </S.Wrapper>
  );
};

export default StatusWorkflow;
